import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { LabeledInputComponent } from "../../../../shared/components/labeled-input/labeled-input.component";
import { CustomButtonComponent } from "../../../../shared/components/custom-button/custom-button.component";
import { FileDetailsViewComponent } from "../../components/file-details-view/file-details-view.component";
import { ToastComponent } from "../../../../shared/components/toast/toast.component";
import { FilesService } from '../../../../core/api/files.service';
import { ApiErrorService } from '../../../../core/api/api-error.service';
import { FullFileDataResponse } from '../../../../core/interfaces/file-upload-interfaces';
import { lastValueFrom } from 'rxjs';
import { CommonModule } from '@angular/common';
import { AdminNavigationComponent } from "../../components/admin-navigation/admin-navigation.component";
import { AdminTopbarComponent } from "../../components/admin-topbar/admin-topbar.component";

@Component({
  selector: 'app-admin-file-data-page',
  standalone: true,
  imports: [TranslocoPipe, LabeledInputComponent, CustomButtonComponent, FileDetailsViewComponent, ToastComponent, CommonModule, AdminNavigationComponent, AdminTopbarComponent],
  templateUrl: './admin-file-data-page.component.html',
  styleUrl: './admin-file-data-page.component.css'
})
export class AdminFileDataPageComponent {
  constructor(private router: Router, private filesService: FilesService, private apiError: ApiErrorService) { }

  // Toast
  @ViewChild(ToastComponent) toast!: ToastComponent;

  // File Details
  fileIdInput: string = '';
  fileIdInputError: string | null = null;

  fileDetailsResponse: FullFileDataResponse | null = null;
  loadingResponse = false;

  goToDashboard() {
    this.router.navigate(["/dashboard"]);
  }

  async loadFileSummary() {
    const fileId = this.fileIdInput.trim();
    this.loadingResponse = true;
    this.fileDetailsResponse = null;

    try {
      const response = await lastValueFrom(this.filesService.getFileFullData(fileId));
      this.fileDetailsResponse = response;
    } catch (error) {
      this.toast.showToast("shared.error", "admin.not_found", "error", 3000, true)
    }
    this.loadingResponse = false;
  }
}
